import axios from "axios";
import { authHeaders } from "./nodeAuthService";
import { API_BASE_URL } from "../config/api";

const BASE_URL = `${API_BASE_URL}/api/admin/menus`;

function extractError(err) {
  const data = err?.response?.data;
  if (data?.message) return new Error(data.message);
  if (Array.isArray(data?.errors) && data.errors.length) {
    return new Error(data.errors.map((e) => e.msg).filter(Boolean).join(", "));
  }
  return new Error(err?.message || "Unexpected error");
}

function flattenMenus(items = [], acc = []) {
  items.forEach((item) => {
    acc.push(item);
    if (Array.isArray(item.children) && item.children.length) {
      flattenMenus(item.children, acc);
    }
  });
  return acc;
}

export async function fetchMenuTree() {
  try {
    const { data } = await axios.get(BASE_URL, { headers: authHeaders() });
    return data?.results?.data?.menus ?? [];
  } catch (err) {
    throw extractError(err);
  }
}

export async function fetchMenuFlatList() {
  const tree = await fetchMenuTree();
  return flattenMenus(tree);
}

export async function createMenu(payload) {
  try {
    const { data } = await axios.post(BASE_URL, payload, {
      headers: { ...authHeaders(), "Content-Type": "application/json" },
    });
    return data?.results?.data ?? data?.data ?? data;
  } catch (err) {
    throw extractError(err);
  }
}

export async function updateMenu(id, payload) {
  try {
    const { data } = await axios.put(`${BASE_URL}/${id}`, payload, {
      headers: { ...authHeaders(), "Content-Type": "application/json" },
    });
    return data?.results?.data ?? data?.data ?? data;
  } catch (err) {
    throw extractError(err);
  }
}

export async function deleteMenu(id) {
  try {
    const { data } = await axios.delete(`${BASE_URL}/${id}`, { headers: authHeaders() });
    return data;
  } catch (err) {
    throw extractError(err);
  }
}
